import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { LandingHeader } from '../components/LandingHeader';
import { blogPosts, formatPostDate } from '../data/blogPosts';
export function BlogPage() {
  const [featured, ...rest] = blogPosts;
  return <div id="top" className="min-h-screen w-full bg-white text-[#041F60]" data-id="element-556" data-mp="3me43bt2zaj5m">
      <a href="#main-content" className="sr-only fixed left-4 top-4 z-50 rounded-lg bg-[#041F60] px-4 py-2 text-sm font-bold text-white focus:not-sr-only focus:outline-none focus:ring-2 focus:ring-[#4BE4FF]" data-id="element-557" data-mp="3r9swneoen3th">
        Skip to content
      </a>
      <LandingHeader current="/blog" data-id="element-558" data-mp="33l04zuetfi4o" />

      <main id="main-content" data-id="element-559" data-mp="33jyk6y7zzh9r">
        <section className="border-b border-[#A6B6F8]/50 bg-[#A6B6F8]/20" data-id="element-560" data-mp="33nw1rfexg0rj">
          <div className="mx-auto max-w-6xl px-5 py-14 sm:px-8 sm:py-20" data-id="element-561" data-mp="38lxp4cjdym8t">
            <div className="max-w-2xl" data-id="element-562" data-mp="iuivq9w944na">
              <p className="text-xs font-bold uppercase tracking-[0.16em] text-[#5B5299]" data-id="element-563" data-mp="ixn6xr84w0ng">
                Insights
              </p>
              <h1 className="mt-3 text-4xl font-bold tracking-[-0.045em] sm:text-5xl sm:leading-[1.06]" data-id="element-564" data-mp="1rflj1qj27isv">
                Practical writing on credit, collections and cash.
              </h1>
              <p className="mt-5 text-base leading-7 text-[#3A3A3A] sm:text-lg" data-id="element-565" data-mp="1idvvivsat40d">
                Short, useful pieces for owners and finance teams who would
                rather spend less time chasing invoices.
              </p>
            </div>

            <article className="mt-12 grid gap-8 border-y-2 border-[#041F60] bg-white py-10 lg:grid-cols-[1.25fr_0.75fr] lg:items-end lg:gap-14" data-id="element-566" data-mp="18hirb3z4n7rd">
              <div data-id="element-567" data-mp="yq4uj3yk8m1x">
                <div className="flex flex-wrap items-center gap-x-3 gap-y-1 text-xs font-bold uppercase tracking-[0.12em] text-[#5B5299]" data-id="element-568" data-mp="yrg099bkg3vo">
                  <span className="rounded-full bg-[#4BE4FF] px-2.5 py-1 text-[#041F60]" data-id="element-569" data-mp="umq4rlktkrba">
                    Latest
                  </span>
                  <span data-id="element-570" data-mp="kq3m93fyuccf">{featured.category}</span>
                </div>
                <h2 className="font-display mt-5 text-2xl font-bold leading-tight tracking-[-0.01em] sm:text-[1.9rem]" data-id="element-571" data-mp="kszkksvq731e">
                  <a href={`/blog/${featured.slug}`} className="underline-offset-4 hover:underline focus:underline focus:outline-none" data-id="element-572" data-mp="g1ucb053f0df">
                    {featured.title}
                  </a>
                </h2>
                <p className="mt-4 max-w-xl text-base leading-7 text-[#3A3A3A]" data-id="element-573" data-mp="65rcw21mlfu6">
                  {featured.excerpt}
                </p>
              </div>
              <div className="lg:text-right" data-id="element-574" data-mp="yrahi0rq3h06">
                <p className="text-sm font-semibold text-[#041F60]" data-id="element-575" data-mp="k3pes7yrfjss">
                  {formatPostDate(featured.date)}
                </p>
                <p className="mt-1 text-sm text-stone-500" data-id="element-576" data-mp="p1qx2qod3f37">
                  {featured.readingMinutes} min read ·{' '}
                  {featured.author}
                </p>
                <a href={`/blog/${featured.slug}`} className="font-display mt-7 inline-flex items-center gap-2 bg-[#041F60] px-9 py-4 text-[13px] font-bold uppercase tracking-[0.13em] text-white transition-colors duration-150 hover:bg-[#031849] focus:outline-none focus:ring-2 focus:ring-[#041F60] focus:ring-offset-2" data-id="element-577" data-mp="1hitla9tkmz39">
                  Read article <ArrowRightIcon size={16} aria-hidden="true" data-id="element-578" data-mp="3708k9bwhxl49" />
                </a>
              </div>
            </article>
          </div>
        </section>

        <section className="bg-white" data-id="element-579" data-mp="2jb65cbt8y6dg">
          <div className="mx-auto max-w-6xl px-5 py-16 sm:px-8 sm:py-20" data-id="element-580" data-mp="2ebjidanm9brg">
            <h2 className="text-sm font-bold uppercase tracking-[0.16em] text-[#5B5299]" data-id="element-581" data-mp="2ednuugzkzj3c">
              More articles
            </h2>
            <ul className="mt-8 grid border-t border-stone-200 md:grid-cols-2 lg:grid-cols-3" data-id="element-582" data-mp="2o9z8baawqezd">
              {rest.map(post => <li key={post.slug} className="h-full border-b border-stone-200 md:border-l md:first:border-l-0" data-id="element-583" data-mp="7jsgbyll5ec5">
                  <article className="flex h-full flex-col py-8 md:px-7 md:first:pl-0" data-id="element-584" data-mp="yu6opnm6cy7m">
                    <p className="text-xs font-bold uppercase tracking-[0.12em] text-[#5B5299]" data-id="element-585" data-mp="12v0cmgzmad0i">
                      {post.category}
                    </p>
                    <h3 className="font-display mt-3 text-base font-bold leading-snug tracking-tight" data-id="element-586" data-mp="17t1uwzp7y8ax">
                      <a href={`/blog/${post.slug}`} className="underline-offset-4 hover:underline focus:underline focus:outline-none" data-id="element-587" data-mp="1cura8rjh584t">
                        {post.title}
                      </a>
                    </h3>
                    <p className="mt-3 text-sm leading-6 text-[#3A3A3A]" data-id="element-588" data-mp="1qlml29dj9zb1">
                      {post.excerpt}
                    </p>
                    <p className="mt-auto pt-6 text-xs font-semibold text-stone-500" data-id="element-589" data-mp="20j0rdg5qt7pm">
                      {formatPostDate(post.date)} · {post.readingMinutes} min
                      read
                    </p>
                  </article>
                </li>)}
            </ul>
          </div>
        </section>

        <section className="navy-texture border-t border-[#031849] text-white" data-id="element-590" data-mp="3l0td48suadht">
          <div className="mx-auto flex max-w-6xl flex-col items-start justify-between gap-8 px-5 py-14 sm:px-8 sm:py-20 md:flex-row md:items-center" data-id="element-591" data-mp="3g1q5qhpdzv6o">
            <div className="max-w-xl" data-id="element-592" data-mp="3b4gd6t6pb3em">
              <h2 className="font-display text-2xl font-bold uppercase leading-tight tracking-[0.02em] sm:text-[2.1rem]" data-id="element-593" data-mp="cl9ltfbqb55e">
                Stop reading about late payment
              </h2>
              <p className="mt-3 text-base leading-7 text-[#A6B6F8]" data-id="element-594" data-mp="7oj0odl2hjd4">
                Start your free trial and bring credit, collections and invoice
                finance into one practical view.
              </p>
            </div>
            <a href="/signup" className="font-display inline-flex shrink-0 items-center gap-2 bg-[#4BE4FF] px-9 py-4 text-[13px] font-bold uppercase tracking-[0.13em] text-[#041F60] transition-colors duration-150 hover:bg-[#38d9f2] focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-[#041F60]" data-id="element-595" data-mp="vc0sua88ujgm">
              Start your free trial{' '}
              <ArrowRightIcon size={16} aria-hidden="true" data-id="element-596" data-mp="2b21oetg3jlj7" />
            </a>
          </div>
        </section>
      </main>

      <footer className="border-t border-stone-200 bg-white" data-id="element-597" data-mp="2g0bnhf4xz6a3">
        <div className="mx-auto flex max-w-6xl flex-col gap-5 px-5 py-8 sm:flex-row sm:items-center sm:justify-between sm:px-8" data-id="element-598" data-mp="222575cw1doy6">
          <p className="text-sm font-semibold text-[#041F60]" data-id="element-599" data-mp="265jp493jcfe9">Credit Manager</p>
          <a href="mailto:support@creditmanager.co.uk" className="text-sm font-semibold text-[#5B5299] underline decoration-[#A6B6F8] underline-offset-4 transition hover:text-[#041F60] focus:text-[#041F60] focus:outline-none" data-id="element-600" data-mp="1s58xh3ueiws1">
            Contact support
          </a>
          <p className="text-xs text-stone-500" data-id="element-601" data-mp="3rg0b88q0s9by">© 2026 Credit Manager</p>
        </div>
      </footer>
    </div>;
}